import React, { useState, useContext } from 'react';
import cx from 'classnames';

import InfinityMediaItemConfigContext from '../Context/infinite-media-item-config-context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons';
import Popover, { Alignment } from '~/App/Components/Popover';
import DropdownMenu from '~/App/Components/DropdownMenu';

export interface ActionLink {
  label: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export interface ActionLinksProps {
  links: ActionLink[];
  className?: string;
}

export default function ActionLinks({ links, className }: ActionLinksProps) {
  const [isOpen, setOpen] = useState(false);

  const itemConfig = useContext(InfinityMediaItemConfigContext);
  const { selectMode } = itemConfig;
  const closePopover = () => setOpen(false);

  return (
    <Popover
      className={className}
      align={Alignment.Right}
      preferPlace='below'
      isOpen={isOpen}
      onOuterAction={closePopover}
      tipSize={0.1}
      body={
        <DropdownMenu>
          <DropdownMenu.ItemGroup>
            {links.map(({ label, onClick, className }, index) => (
              <DropdownMenu.Item
                key={index}
                className={className}
                onClick={() => {
                  onClick?.();
                  closePopover();
                }}
              >
                <div
                  className={cx('flex items-center gap-x-4 text-neutral-900')}
                >
                  {label}
                </div>
              </DropdownMenu.Item>
            ))}
          </DropdownMenu.ItemGroup>
        </DropdownMenu>
      }
    >
      {!selectMode && (
        <div
          className={cx(
            [
              'cursor-pointer rounded-full',
              'self-center flex justify-center items-center w-[30px] h-[30px]',
            ],
            {
              'v2-bg-yellow-500 v2-text-neutral-900': isOpen,
              'v2-text-neutral-500 hover:v2-bg-yellow-200': !isOpen,
            }
          )}
          onClick={() => setOpen(!isOpen)}
        >
          <FontAwesomeIcon icon={faEllipsisH} />
        </div>
      )}
    </Popover>
  );
}
